/**
 * Tipos globais do Design System
 * Define severities e mapeamentos compartilhados entre componentes
 */

/**
 * Severities globais do Design System
 * Representam as intenções visuais dos componentes
 */
export type Severity = 
  | "primary" 
  | "secondary" 
  | "neutral" 
  | "success" 
  | "warning" 
  | "danger";

/**
 * Severities para componentes de feedback (Badge, Toast, etc)
 */
export type FeedbackSeverity = 
  | "success" 
  | "info" 
  | "warning" 
  | "danger";

/**
 * Map de severities do DS para severities do PrimeReact
 * null indica que será customizado via CSS
 */
export const SEVERITY_TO_PRIME_MAP: Record<Severity, string | null> = {
  primary: "primary",
  secondary: "secondary",
  neutral: "contrast",
  success: "success",
  warning: "warning",
  danger: "danger"
};
